import { render, staticRenderFns } from "./Carousels.vue?vue&type=template&id=097c1243&"
import script from "./Carousels.vue?vue&type=script&lang=js&"
export * from "./Carousels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('097c1243')) {
      api.createRecord('097c1243', component.options)
    } else {
      api.reload('097c1243', component.options)
    }
    module.hot.accept("./Carousels.vue?vue&type=template&id=097c1243&", function () {
      api.rerender('097c1243', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/carousel/Carousels.vue"
export default component.exports